import React from 'react';
import {
  // FaFacebook,
  FaInstagram,
  // FaYoutube,
  // FaTwitter,
  FaLinkedin,
} from 'react-icons/fa';
import {
  // MdContactMail,
  // MdContactPhone,
  MdCall,
  MdEmail,
  MdLocationOn,
} from 'react-icons/md';
import { ImUserTie } from 'react-icons/im';

// import { UnnatiLogo } from '../../icons/UnnatiTree.svg';

import {
  FooterContainer,
  FooterWrap,
  FooterInfoContainer,
  SocialLogo,
  SocialIcons,
  InfoSection,
  FooterSectionTitle,
  FooterSectionItems,
  SectionItem,
  IconContainer,
  ItemTitle,
  SocialMedia,
  SocialMediaWrap,
  WebsiteRights,
  SocialIconLink,
} from './homepage-footer.styles';

// Container contains 2 FooterLinksWrapper(s) which will be the 2 columns in the mobile version
// each wrapper contains 2 FooterLinkItems (s)
// NOTE : if you wanna make the footer links actual links, make them an <a> tag instead of react router links

const HomepageFooter = () => {
  return (
    <FooterContainer id='footer'>
      <FooterWrap>
        <FooterInfoContainer>
          <SocialLogo to='/'>UNNATI</SocialLogo>
          <InfoSection>
            <FooterSectionTitle>GET IN TOUCH</FooterSectionTitle>
            <FooterSectionItems>
              <SectionItem>
                <IconContainer>
                  <ImUserTie />
                </IconContainer>
                <ItemTitle>
                  S. Aditya
                  <br /> Project Head <br /> Unnati
                </ItemTitle>
              </SectionItem>
              <SectionItem>
                <IconContainer>
                  <MdCall />
                </IconContainer>
                <ItemTitle>+91 9968619080</ItemTitle>
              </SectionItem>
              <SectionItem>
                <IconContainer>
                  {/* <MdContactPhone /> */}
                  <MdEmail />
                </IconContainer>
                <ItemTitle>dtuenactus@gmail.com</ItemTitle>
              </SectionItem>
              <SectionItem>
                <IconContainer>
                  {/* <MdContactPhone /> */}
                  <MdLocationOn />
                </IconContainer>
                <ItemTitle>
                  Delhi Technological University, <br /> Shahbad Daulatpur, Main
                  Bawana Road, Delhi-110042. India
                </ItemTitle>
              </SectionItem>
            </FooterSectionItems>
            <FooterSectionTitle>FOLLOW US ON</FooterSectionTitle>
            {/* 
            <FooterLinkItems>
              <MdContactMail />
            </FooterLinkItems> */}
            <SocialIcons>
              <SocialIconLink
                href='https://www.linkedin.com/company/enactus-dtu/'
                target='_blank'
                aria-label='Linkedin'
              >
                <FaLinkedin />
              </SocialIconLink>
              <SocialIconLink
                href='https://www.instagram.com/enactusdtu.unnati/'
                target='_blank'
                aria-label='Instagram'
              >
                <FaInstagram />
              </SocialIconLink>
            </SocialIcons>
          </InfoSection>

          {/* <FooterLinkItems>
            <FooterLink>
              <ContactIcon>
                <MdContactPhone />
              </ContactIcon>
            </FooterLink>
            <FooterLink to='/'>Ambassadors</FooterLink>
            <FooterLink to='/'>Agency</FooterLink>
            <FooterLink to='/'>Influencer</FooterLink>
          </FooterLinkItems> */}
        </FooterInfoContainer>

        {/* <FooterLinkTitle>FOLLOW US</FooterLinkTitle> */}

        <SocialMedia>
          <SocialMediaWrap>
            {/* <SocialLogo to='/'>UNNATI</SocialLogo> */}
            {/* <Address>
              Delhi Technological University, Shahbad Daulatpur, Main Bawana
              Road, Delhi-110042. India
            </Address> */}
            <WebsiteRights>
              Enactus DTU © {new Date().getFullYear()} All rights reserved.
            </WebsiteRights>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

// const HomepageFooter = () => {
//   return (
//     <FooterContainer id='footer'>
//       <FooterWrap>
// <FooterLinksContainer>
//   <FooterLinksWrapper>
//     <FooterLinkItems>
//       <FooterLinkTitle>About Us</FooterLinkTitle>
//       <FooterLink to='/'>How it works</FooterLink>
//       <FooterLink to='/'>Testimonials</FooterLink>
//       <FooterLink to='/'>Careers</FooterLink>
//       <FooterLink to='/'>Investors</FooterLink>
//       <FooterLink to='/'>Terms of Service</FooterLink>
//     </FooterLinkItems>
//     <FooterLinkItems>
//       <FooterLinkTitle>Contact Us</FooterLinkTitle>
//       <FooterLink to='/'>Contact</FooterLink>
//       <FooterLink to='/'>Support</FooterLink>
//       <FooterLink to='/'>Destinations</FooterLink>
//       <FooterLink to='/'>Sponsorships</FooterLink>
//     </FooterLinkItems>
//   </FooterLinksWrapper>
//   <FooterLinksWrapper>
// <FooterLinkItems>
//   <FooterLinkTitle>Videos</FooterLinkTitle>
//   <FooterLink to='/'>Submit Videos</FooterLink>
//   <FooterLink to='/'>Ambassadors</FooterLink>
//   <FooterLink to='/'>Agency</FooterLink>
//   <FooterLink to='/'>Influencer</FooterLink>
// </FooterLinkItems>
//     <FooterLinkItems>
//       <FooterLinkTitle>Social Media</FooterLinkTitle>
//       <FooterLink to='/'>Instagram</FooterLink>
//       <FooterLink to='/'>Facebook</FooterLink>
//       <FooterLink to='/'>Youtube</FooterLink>
//       <FooterLink to='/'>Twitter</FooterLink>
//     </FooterLinkItems>
//   </FooterLinksWrapper>
// </FooterLinksContainer>
// <SocialMedia>
//   <SocialMediaWrap>
//     <SocialLogo to='/'>UNNATI</SocialLogo>
//     <WebsiteRights>
//       Enactus DTU © {new Date().getFullYear()} All rights reserved.
//     </WebsiteRights>
//     {/* <SocialIcons>
//       <SocialIconLink
//         href='https://www.linkedin.com/company/enactus-dtu/'
//         target='_blank'
//         aria-label='Linkedin'
//       >
//         <FaLinkedin />
//       </SocialIconLink>
//       <SocialIconLink
//         href='https://www.instagram.com/enactusdtu.unnati/'
//         target='_blank'
//         aria-label='Instagram'
//       >
//         <FaInstagram />
//       </SocialIconLink>

//       <SocialIconLink
//         href='https://www.facebook.com/EnactusDTU'
//         target='_blank'
//         aria-label='Facebook'
//       >
//         <FaFacebook />
//       </SocialIconLink>

//       <SocialIconLink href='/' target='_blank' aria-label='Youtube'>
//         <FaYoutube />
//       </SocialIconLink>
//       <SocialIconLink
//         href='//www,twitter.com/briandesignz'
//         target='_blank'
//         aria-label='Twitter'
//       >
//         <FaTwitter />
//       </SocialIconLink>
//     </SocialIcons> */}
//   </SocialMediaWrap>
// </SocialMedia>
//       </FooterWrap>
//     </FooterContainer>
//   );
// };

export default HomepageFooter;
